import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { Guid } from '@web/utils';
import { PublicFaqCategoryQuestionResponse } from './public-faq-category-question.response';

@jsonObject
export class PublicFaqCategoryCollectionItemResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly name!: string;

  @jsonMember(String)
  public readonly slug!: string;

  @jsonArrayMember(PublicFaqCategoryQuestionResponse)
  public readonly questions!: PublicFaqCategoryQuestionResponse[];
}
